import type { ReduxRootState } from 'types';

interface Params {
  messages: ReduxRootState['messages'];
}

const getDefaultAccessAndVisibilityLabels = ({ messages }: Params) => ({
  headerRestrictions: messages.commonRestrictions,
  headerUserAccess: messages.accessAndVisibilityHeaderUserAccess,
  headerUserAccessHelpText: '',
  headerUserLimits: messages.accessAndVisibilityHeaderUserLimits,
  headerUserLimitsHelpText: '',
  restrictionOptionNone: messages.accessAndVisibilityRestrictionOptionNone,
  restrictionOptionUserLimit:
    messages.accessAndVisibilityRestrictionOptionUserLimit,
  restrictionOptionUserRequest:
    messages.accessAndVisibilityRestrictionOptionUserRequest,
  visibilityCriteriaOptionError: messages.commonSelectAtLeastOneOption,
  visibilityCriteriaOptionGroups:
    messages.accessAndVisibilityVisibilityCriteriaGroups,
  visibilityCriteriaOptionGroupsDisabled:
    messages.accessAndVisibilityVisibilityCriteriaGroupsDisabled,
  visibilityCriteriaOptionGroupsTooltip:
    messages.accessAndVisibilityVisibilityCriteriaGroupsTooltip,
  visibilityCriteriaOptionSSO:
    messages.accessAndVisibilityVisibilityCriteriaSSO,
  visibilityCriteriaOptionSSOTooltip: '',
  visibilityCriteriaOptionUserAttributes:
    messages.accessAndVisibilityVisibilityCriteriaUserAttributes,
  visibilityCriteriaOptionUserAttributesDisabled:
    messages.accessAndVisibilityVisibilityCriteriaUserAttributesDisabled,
  visibilityCriteriaOptionUserAttributesTooltip:
    messages.accessAndVisibilityVisibilityCriteriaUserAttributesTooltip,
  visibilityCriteriaOptionUsers:
    messages.accessAndVisibilityVisibilityCriteriaUsers,
  visibilityCriteriaOptionUsersTooltip:
    messages.accessAndVisibilityVisibilityCriteriaUsersTooltip,
  visibilityOptionAnyone: messages.settingsRegistered,
  visibilityOptionLimited: messages.accessAndVisibilityVisibilityOptionLimited,
  visibilityOptionPrivate: messages.settingsAddedUsersOnly,
  visibilityOptionPublic: messages.accessAndVisibilityVisibilityOptionPublic
});

export default getDefaultAccessAndVisibilityLabels;
